module.exports = __webpack_public_path__ + "img/IEC13767.ec1413ac.png";